// The window.postMessage contract between the browser extension and this app.
//
// These names cross a trust boundary between two separately-built codebases, so
// they cannot be a shared import: the extension's copy lives in
// extension/src/content/website-bridge.js, which is a content script and cannot
// import ES modules. Changing a name means changing both files.
//
// Everything on this side of the boundary imports from here rather than typing
// the string, so at least a rename within the app lands everywhere at once. The
// original bug was three components each spelling 'cs2pt:sync_complete' while the
// bridge emitted 'cs2pt:sync:complete'; nothing errored, background syncs just
// never reached the page.

/** Sent by the page, relayed to the extension background. */
export const EXT_REQUEST = {
  LINK_TOKEN: 'cs2pt:link:token',
  STATUS:     'cs2pt:request:status',
  SYNC:       'cs2pt:request:sync',
  // Live "who is Steam signed in as right now". Answers on EXT_EVENT.STATUS,
  // carrying the same shape as a normal status plus a fresh reading.
  WHOAMI:     'cs2pt:request:whoami',
};

/** Sent by the extension bridge, listened for by the page. */
export const EXT_EVENT = {
  STATUS:        'cs2pt:status',
  LINK_RESULT:   'cs2pt:link:result',
  SYNC_RESULT:   'cs2pt:sync:result',
  SYNC_PROGRESS: 'cs2pt:sync:progress',
  SYNC_COMPLETE: 'cs2pt:sync:complete',
  SYNC_ERROR:    'cs2pt:sync:error',
};

/** Dispatched on `document` by the bridge once it has injected. */
export const EXT_READY_EVENT = 'cs2pt:extension:ready';

/** Ask the extension for its current status. Safe to call when not installed. */
export function requestExtensionStatus() {
  window.postMessage({ type: EXT_REQUEST.STATUS }, window.location.origin);
}

/**
 * Ask the extension to check with Steam who is signed in right now.
 *
 * Costs a request to steamcommunity.com, so this is user-triggered rather than
 * something the page does on mount. The reply arrives on EXT_EVENT.STATUS like
 * any other status update.
 */
export function requestSteamWhoami() {
  window.postMessage({ type: EXT_REQUEST.WHOAMI }, window.location.origin);
}
